import {
	FIND_ALERT_BY_ID_QUERY,
	FIND_ALERT_EXECUTION_BY_ID_QUERY,
	FIND_ALERT_NOTIFICATION_MARKET_STATE_QUERY,
	FIND_COMPANY_HOTEL_ALERTS_QUERY,
	FIND_COMPETITORS_PRICE_RATE_ALERT_EXECUTION_NOTIFICATIONS_QUERY,
	FIND_COMPETITORS_SOLD_OUT_ALERT_EXECUTION_NOTIFICATIONS_QUERY,
	FIND_PARITY_PRICE_COMPARISON_ALERT_EXECUTION_NOTIFICATIONS_QUERY,
	FIND_PRICE_COMPARISON_ALERT_EXECUTION_NOTIFICATIONS_QUERY,
	FIND_SUCCESSFUL_ALERT_EXECUTIONS_QUERY,
	REMOVE_ALERT_MUTATION,
	SAVE_ALERT_MUTATION,
} from '@app/model/alert/service/AlertGraphQLQueries';
import AlertInput from '@app/model/alert/input/AlertInput';
import AlertExecution from '@app/model/alert/AlertExecution';
import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import AlertOutput from '@app/model/alert/AlertOutput';
import PriceComparisonAlertExecutionNotificationOutput
	from '@app/model/alert/output/PriceComparisonAlertExecutionNotificationOutput';
import CompetitorsPriceRateAlertExecutionNotificationOutput
	from '@app/model/alert/output/CompetitorsPriceRateAlertExecutionNotificationOutput';
import ParityPriceComparisonAlertExecutionNotificationOutput
	from '@app/model/alert/output/ParityPriceComparisonAlertExecutionNotificationOutput';
import CompetitorsSoldOutAlertExecutionNotificationOutput
	from '@app/model/alert/output/CompetitorsSoldOutAlertExecutionNotificationOutput';
import { MarketStateStatDateSnapshot } from '@app/model/market_state/MarketStateStatDateSnapshot';

const LEGACY_NULL_RADIO_VALUES = ['__FORM_RADIO_NULL__', '__FORM_RADIO_UNDEFINED__'];

class AlertService {

	public static saveAlert = (input: AlertInput): Promise<AlertOutput> => {
		const normalizedInput = LEGACY_NULL_RADIO_VALUES.includes(input.filter?.meal as unknown as string)
			? { ...input, filter: { ...input.filter, meal: null } }
			: input;

		return GraphQLExecutor.execute<AlertOutput>(SAVE_ALERT_MUTATION, { input: normalizedInput });
	};
	public static removeAlert = (variables: { companyHotelId: number, alertId: number }): Promise<AlertOutput[]> => {
		return GraphQLExecutor.execute<AlertOutput[]>(REMOVE_ALERT_MUTATION, variables);
	};
	public static findAlerts = (companyHotelId: number): Promise<AlertOutput[]> => {
		return GraphQLExecutor.execute<AlertOutput[]>(FIND_COMPANY_HOTEL_ALERTS_QUERY, { companyHotelId });
	};
	public static findAlertById = (companyHotelId: number, alertId: number): Promise<AlertOutput> => {
		return GraphQLExecutor.execute<AlertOutput>(FIND_ALERT_BY_ID_QUERY, { companyHotelId, alertId });
	};
	public static findAlertExecutionById = (companyHotelId: number, alertExecutionId: number): Promise<AlertExecution> => {
		return GraphQLExecutor.execute<AlertExecution>(FIND_ALERT_EXECUTION_BY_ID_QUERY, { companyHotelId, alertExecutionId });
	};
	public static findAlertExecutions = (companyHotelId: number, alertId: number): Promise<AlertExecution[]> => {
		return GraphQLExecutor.execute<AlertExecution[]>(FIND_SUCCESSFUL_ALERT_EXECUTIONS_QUERY, { companyHotelId, alertId });
	};
	public static findAlertNotificationMarketState = (variables: {
		companyHotelId: number,
		alertId: number,
		marketStateId: number
	}) => {
		return GraphQLExecutor.execute<MarketStateStatDateSnapshot>(FIND_ALERT_NOTIFICATION_MARKET_STATE_QUERY, variables);

	};
	public static findPriceComparisonAlertExecutionNotifications = (companyHotelId: number, alertExecutionId: number) => {
		return GraphQLExecutor.execute<PriceComparisonAlertExecutionNotificationOutput[]>(FIND_PRICE_COMPARISON_ALERT_EXECUTION_NOTIFICATIONS_QUERY, { companyHotelId, alertExecutionId });
	};

	public static findCompetitorsPriceRateAlertExecutionNotifications = (companyHotelId: number, alertExecutionId: number) => {
		return GraphQLExecutor.execute<CompetitorsPriceRateAlertExecutionNotificationOutput[]>(FIND_COMPETITORS_PRICE_RATE_ALERT_EXECUTION_NOTIFICATIONS_QUERY, { companyHotelId, alertExecutionId });
	};

	public static findParityPriceComparisonAlertExecutionNotifications = (companyHotelId: number, alertExecutionId: number) => {
		return GraphQLExecutor.execute<ParityPriceComparisonAlertExecutionNotificationOutput[]>(FIND_PARITY_PRICE_COMPARISON_ALERT_EXECUTION_NOTIFICATIONS_QUERY, { companyHotelId, alertExecutionId });
	};

	public static findCompetitorsSoldOutAlertExecutionNotifications = (companyHotelId: number, alertExecutionId: number) => {
		return GraphQLExecutor.execute<CompetitorsSoldOutAlertExecutionNotificationOutput[]>(FIND_COMPETITORS_SOLD_OUT_ALERT_EXECUTION_NOTIFICATIONS_QUERY, { companyHotelId, alertExecutionId });
	};
}

export default AlertService;
